<template>
	<div>
		<div class="modal-title" style="border-bottom: 1px solid #e8eaec;">
			<div class="layout-title-left">
				<img src="/static/imgs/feiyong.png" class="jxyd-imgicon" />
				额外费用
			</div>
			<div class="layout-title-right">
			</div>
		</div>
		<div style="padding:15px 10px;">
			<div>
				<Button type="success" @click="openExtraCostModal">
					<Icon type="md-add-circle" size='18' />
					添加费用
				</Button>
				<span style="padding-left:20px;">
					注：“我方垫付”影响应付款减少；“对方垫付”影响应付款增加；“我方自付”不影响应付款
				</span>
			</div>
			<div>
				<table class="extraCostShowTable">
					<tr v-for="item in extraCostInfos">
						<td>{{item.type}}：</td>
						<td>{{item.advancePayWay}}￥{{item.amount}}</td>
						<td>（{{item.payAccount}}）</td>
					</tr>
				</table>
			</div>
		</div>
		<Modal v-model="extraCostModal" draggable sticky scrollable :width="800">
			<p slot="header" class="modal-header">
				<img src="/static/imgs/feiyong.png" class="jxyd-imgicon" />
				<span style="padding-left:6px;">额外费用</span>
			</p>
			<div style="width:100%;background-color:#fff;border-radius:5px;height:400px;overflow:auto;">
				<Table :columns="extraCostTableColumns" :data="extraCostData"></Table>
			</div>
			<div slot="footer">
				<table style="float: left;" class="extraAmountTab">
					<tr>
						<td style="padding-right:15px;border-right:1px solid #DCDFE6;">
							<span style="font-size: 16px;font-weight: bold;color: var(--font1Color);">垫付：</span>
							<span style="color: #ff4d4d;font-size: 22px;">￥{{extraAdvancePay}}</span>
						</td>
						<td style="padding-left: 15px;padding-right:15px;border-right:1px solid #DCDFE6;">
							<span style="font-size: 16px;font-weight: bold;color: var(--font1Color);">自付：</span>
							<span style="color: #ff4d4d;font-size: 22px;">￥{{extraSelfPay}}</span>
						</td>
						<td style="padding-left: 15px;">
							<span style="font-size: 16px;font-weight: bold;color: var(--font1Color);">对方垫付：</span>
							<span style="color: #ff4d4d;font-size: 22px;">￥{{dfAdvancePay}}</span>
						</td>
					</tr>
				</table>
				<button class="jxyd-button jxyd-primary" @click="openExtraCostModal">重置</button>
				<button class="jxyd-button" @click="extraCostModalOk">确定</button>
			</div>
		</Modal>
		<Modal v-model="configModal" draggable sticky scrollable>
			<p slot="header" style="text-align:left">
				<Icon type="ios-create-outline" size='18' />
				<span> 添加选项</span>
			</p>
			<div style="width:100%;padding:5px;background-color:#fff;border-radius:5px;height:300px;overflow:auto;">
				<table style="width:100%;">
					<tr>
						<td style="width:100%;" colspan="2">
							<Input v-model="dictionaryFormItem.key" placeholder="请输入选项"
								@keyup.enter.native="addType()" />
						</td>
					</tr>
					<tr>
						<td class="tab-hander" style="width: 180px;">选项</td>
						<td class="tab-hander" style="text-align:center;">操作</td>
					</tr>
					<tr v-for="item in typeList">
						<td>{{item.key}}</td>
						<td style="text-align:center;">
							<Icon type="md-trash" size='18' class="icon-item-dele" @click.stop="deleType(item.id)" />
						</td>
					</tr>
				</table>
			</div>
			<div slot="footer">
				<button class="jxyd-button jxyd-primary" @click="configModal = false;">关闭</button>
				<button class="jxyd-button" @click="addType()">保存</button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import request from '@/utils/request'
	import formatNum from '@/utils/formatNum'
	export default {
		name: 'extracostdata',
		props: ['selectedExtraCost'],
		data() {
			return {
				extraCostModal: false,
				extraCostInfos: [],
				typeList: [],
				typePid: 'fylx',
				accountPid: 'sfkzh',
				payWayOptionList: [],
				advancePayWayList: ['我方垫付', '对方垫付', '我方自付'],
				extraCostData: [],
				extraAdvancePay: 0,
				extraSelfPay: 0,
				dfAdvancePay: 0,
				configModal: false,
				extraCostTableColumns: [{
						title: '行号',
						key: 'guid',
						width: 80
					},
					{
						title: '费用类型',
						key: 'type',
						width: 160,
						render: (h, params) => {
							return [h('Select', {
									props: {
										transfer: true,
										value: params.row.type
									},
									style: {
										width: '75%'
									},
									on: {
										input: (event) => {
											this.extraCostData[params.index].type = event;
										}
									},
								},
								this.typeList.map(function(type) {
									return h('Option', {
										props: {
											value: type.key,
											key: type.key
										}
									}, type.key);
								})
							), h('Icon', {
								style: {
									cursor: 'pointer',
								},
								props: {
									type: "ios-settings-outline",
									size: 24
								},
								on: {
									click: (e) => {
										this.configModal = true;
									}
								}
							})];
						}
					},
					{
						title: '垫付方式',
						key: 'advancePayWay',
						render: (h, params) => {
							let self = this;
							return [h('Select', {
									props: {
										transfer: true,
										value: params.row.advancePayWay
									},
									on: {
										input: (event) => {
											this.extraCostData[params.index].advancePayWay = event;
											if (event == '对方垫付') {
												self.$refs['payAccount' + params.index].disabled =
												true;
											} else {
												self.$refs['payAccount' + params.index].disabled =
													false;
											}
											this.extraCostData[params.index].payAccount = '';
											this.extraCostData[params.index].amount = 0;
										}
									},
								},
								this.advancePayWayList.map(function(type) {
									return h('Option', {
										props: {
											value: type
										}
									}, type);
								})
							)]
						}
					},
					{
						title: '结算账户',
						key: 'payAccount',
						render: (h, params) => {
							let create = this.$createElement;
							let dom = create('Select', {
									ref: 'payAccount' + params.index,
									props: {
										transfer: true,
										value: params.row.payAccount,
										disabled: this.extraCostData[params.index].advancePayWay == '对方垫付'
									},
									on: {
										input: (event) => {
											this.extraCostData[params.index].payAccount = event;
										}
									},
								},
								this.payWayOptionList.map(function(type) {
									return h('Option', {
										props: {
											value: type.key
										}
									}, type.key);
								})
							);

							return dom;
						}
					},
					{
						title: '金额（元）',
						key: 'amount',
						render: (h, params) => {
							return [h('InputNumber', {
								props: {
									min: 0,
									value: params.row.amount
								},
								on: {
									input: (e) => {
										this.extraCostData[params.index].amount = e;
										this.$nextTick(function() {
											if (!params.row.type) {
												this.$Notice.error({
													title: '错误提示',
													duration: 3,
													desc: "费用类型不可为空！"
												});
												this.extraCostData[params.index].amount =
												0;
											} else if (!params.row.advancePayWay) {

												this.$Notice.error({
													title: '错误提示',
													duration: 3,
													desc: "垫付方式不可为空！"
												});
												this.extraCostData[params.index].amount =
												0;
											} else if (!params.row.payAccount && params.row
												.advancePayWay != "对方垫付") {
												this.$Notice.error({
													title: '错误提示',
													duration: 3,
													desc: "结算账户不可为空！"
												});
												this.extraCostData[params.index].amount =
												0;
											}
										});

									}
								}
							})]
						}
					},
					{
						title: '操作',
						key: 'action',
						align: 'center',
						render: (h, params) => {
							var btnArr = [];
							btnArr.push(h('Icon', {
								style: {
									cursor: 'pointer',
									'margin-right': '10px'
								},
								props: {
									type: 'md-add-circle',
									size: 24,
									color: '#ff6a7f'
								},
								on: {
									click: (e) => {
										this.extraCostData.push({
											guid: this.extraCostData.length + 1,
											type: '',
											advancePayWay: '',
											payAccount: '',
											amount: 0
										});
									}
								}
							}));
							btnArr.push(h('Icon', {
								style: {
									cursor: 'pointer',
								},
								props: {
									type: 'ios-remove-circle-outline',
									size: 24
								},
								on: {
									click: (e) => {
										if (this.extraCostData.length > 1) {
											this.extraCostData.splice(params.index, 1);
											for (var i = 0; i < this.extraCostData.length; i++) {
												this.extraCostData[i].guid = i + 1;
											}
										}
									}
								}
							}));
							return btnArr;
						}
					}
				],
				dictionaryFormItem: {
					id: 0,
					key: '',
					value: '',
					pid: 0,
					pcode: '',
					creator: parseInt(localStorage.getItem("userId"))
				},
			}
		},
		methods: {
			openExtraCostModal() {
				this.extraCostData = [];
				for (var i = 0; i < this.extraCostInfos.length; i++) {
					this.extraCostData.push({
						guid: i + 1,
						type: this.extraCostInfos[i].type,
						advancePayWay: this.extraCostInfos[i].advancePayWay,
						payAccount: this.extraCostInfos[i].payAccount,
						amount: this.extraCostInfos[i].amount
					});
				}
				if (this.extraCostData.length <= 0) {
					this.extraCostData.push({
						guid: 1,
						type: '',
						advancePayWay: '',
						payAccount: '',
						amount: 0
					});
				}
				this.initPayWayOptionList();
				this.extraCostModal = true;
			},
			extraCostModalOk() {
				if (this.extraAdvancePay > 0 || this.extraSelfPay > 0 || this.dfAdvancePay > 0) {
					this.extraCostInfos = this.extraCostData;
				} else {
					this.extraCostInfos = [];
				}
				this.$emit('update:selectedExtraCost', this.extraCostInfos);
				this.extraCostModal = false;
			},
			initTypeOptionList() {
				let self = this;
				//获取收付款账户数据字典
				request.get('/api/DataDictionary/GetDataDictionaryList', {
					params: {
						code: this.typePid
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取收付款账户数据失败：" + response.errorMsg
						});
						return;
					}
					self.typeList = response.data;
				}).catch(function(error) {})
			},
			initPayWayOptionList() {
				let component = this;
				//获取收付款账户数据字典
				request.get('/api/DataDictionary/GetDataDictionaryList', {
					params: {
						code: this.accountPid
					}
				}).then(function(response) {
					if (response.state == 0) {
						component.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取收付款账户数据失败：" + response.errorMsg
						});
						return;
					}
					component.payWayOptionList = response.data;
				}).catch(function(error) {})
			},
			addType() {
				if (!this.dictionaryFormItem.key) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: '显示名不可为空!'
					});
					return;
				}
				this.dictionaryFormItem.value = this.dictionaryFormItem.key;
				this.dictionaryFormItem.pcode = this.typePid;
				let self = this;
				request.post('/api/DataDictionary/AddDataDictionary', this.dictionaryFormItem).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: '保存失败:' + response.errorMsg
						});
						return;
					}
					self.initTypeOptionList();
					self.dictionaryFormItem.key = '';
					self.dictionaryFormItem.value = '';
					self.$Notice.success({
						title: '正确提示',
						duration: 3,
						desc: '保存成功!'
					});
				}).catch(function(error) {})
			},
			deleType(id) {
				var self = this;
				request.post('/api/DataDictionary/DeleDataDictionary', [id]).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: response.errorMsg
						});
						return;
					}
					self.initTypeOptionList();
					self.$Notice.success({
						title: '正确提示',
						duration: 3,
						desc: '删除成功!'
					});
				}).catch(function(error) {})
			},
		},
		watch: {
			extraCostData: {
				deep: true,
				handler(arr) {
					this.extraAdvancePay = 0;
					this.extraSelfPay = 0;
					this.dfAdvancePay = 0;
					for (let i = 0; i < arr.length; i++) {
						if (arr[i].advancePayWay == "我方垫付") {
							this.extraAdvancePay += arr[i].amount;
						} else if (arr[i].advancePayWay == "对方垫付") {
							this.dfAdvancePay += arr[i].amount;
						} else if (arr[i].advancePayWay == "我方自付") {
							this.extraSelfPay += arr[i].amount;
						}
					}
					this.extraAdvancePay = formatNum(this.extraAdvancePay);
					this.extraSelfPay = formatNum(this.extraSelfPay);
					this.dfAdvancePay = formatNum(this.dfAdvancePay);
				}
			},
			selectedExtraCost: {
				deep: true,
				handler(arr) {
					this.extraCostInfos = arr;
					if (arr.length <= 0) {
						this.extraCostData = [];
					}
				}
			}
		},
		created: function() {
			this.initTypeOptionList();
			this.initPayWayOptionList();
		},
		mounted() {}
	}
</script>

<style scoped>
	.modal-title {
		overflow: hidden;
		padding-bottom: 10px;
		font-size: 16px;
	}

	.layout-title-left {
		float: left;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.layout-title-right {
		float: right;
	}

	.extraCostShowTable {
		margin-top: 10px;
	}

	.extraCostShowTable td {
		padding: 5px;
	}

	.modal-header {
		display: flex;
		justify-content: left;
		align-items: center;
	}

	/deep/ .ivu-table-cell {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.icon-item-dele {
		cursor: pointer;
	}

	.icon-item-dele:hover {
		transform: scale(1.3);
	}
</style>